<template>
  <div class="chart-box patent container">
    <div class="left-box">
      <h2 class="tit">按部门浏览</h2>
      <div class="statistics_tit">
        <span class="statistics_tit_1" style="width:190px">科室</span>
        <!-- <span class="statistics_tit_2">全文量</span> -->
        <span class="statistics_tit_2">专利量</span>
      </div>
      <div class="department">
        <ul
          class="statistics"
          id="con1"
          :class="{anim:animate==true}"
          ref="con1"
          @mouseenter="mEnter(1)"
          @mouseleave="mLeave(1)"
        >
          <li v-for="item in departmentList" :key="item.deptId">
            <a
              class="statistics_tit_1"
              :href="'#/department?id=' + item.deptId"
              style="width:190px"
              :title="item.deptName"
            >{{item.deptName}}</a>
            <!-- <span class="statistics_tit_2">{{item.fullFlag}}</span> -->
            <span class="statistics_tit_2">{{item.num}}</span>
          </li>
        </ul>
      </div>
      <h2 class="tit">按作者浏览</h2>
      <div class="statistics_tit">
        <span class="statistics_tit_1" style="width:190px">作者</span>
        <span class="statistics_tit_2">专利量</span>
      </div>
      <div class="author">
        <ul
          class="statistics"
          id="con2"
          :class="{anim:animate1==true}"
          ref="con2"
          @mouseenter="mEnter(2)"
          @mouseleave="mLeave(2)"
        >
          <li v-for="item in authorList" :key="item.id">
            <a
              class="statistics_tit_1"
              style="width:190px"
              :href="'#/personal?id=' + item.id"
              :title="item.userName"
            >{{item.userName}}</a>
            <span class="statistics_tit_2">{{item.num}}</span>
          </li>
        </ul>
      </div>
    </div>
    <div class="right_box">
      <el-card class="box-card">
        <h2 class="tit">检索</h2>
        <el-form ref="form" :model="searchForm" label-width="80px" size="medium">
          <div class="el-form-item">
            <el-input
              placeholder="请输入内容"
              size="medium"
              v-model="conditions1"
              class="input-with-select"
            >
              <el-select v-model="secondCondition1" slot="prepend" placeholder="请选择">
                <el-option
                  v-for="item in titleOptions"
                  :key="item.value"
                  :label="item.label"
                  :value="item.value"
                ></el-option>
              </el-select>
            </el-input>
          </div>
          <div class="el-form-item">
            <el-input
              placeholder="请输入内容"
              size="medium"
              v-model="conditions2"
              class="input-with-select"
            >
              <el-select
                v-model="firstCondition2"
                class="first-select"
                slot="prepend"
                placeholder="请选择"
              >
                <el-option
                  v-for="item in typeOptions"
                  :key="item.value"
                  :label="item.label"
                  :value="item.value"
                ></el-option>
              </el-select>
              <el-select
                v-model="secondCondition2"
                class="second-select"
                slot="prepend"
                placeholder="请选择"
              >
                <el-option
                  v-for="item in titleOptions"
                  :key="item.value"
                  :label="item.label"
                  :value="item.value"
                ></el-option>
              </el-select>
            </el-input>
          </div>
          <div class="el-form-item">
            <el-input
              placeholder="请输入内容"
              size="medium"
              v-model="conditions3"
              class="input-with-select"
            >
              <el-select
                v-model="firstCondition3"
                class="first-select"
                slot="prepend"
                placeholder="请选择"
              >
                <el-option
                  v-for="item in typeOptions"
                  :key="item.value"
                  :label="item.label"
                  :value="item.value"
                ></el-option>
              </el-select>
              <el-select
                v-model="secondCondition3"
                class="second-select"
                slot="prepend"
                placeholder="请选择"
              >
                <el-option
                  v-for="item in titleOptions"
                  :key="item.value"
                  :label="item.label"
                  :value="item.value"
                ></el-option>
              </el-select>
              <el-button slot="append" icon="el-icon-plus" @click="addSearch"></el-button>
            </el-input>
          </div>
          <div class="el-form-item" v-if="firstAdd">
            <el-input
              placeholder="请输入内容"
              size="medium"
              v-model="conditions4"
              class="input-with-select"
            >
              <el-select
                v-model="firstCondition4"
                class="first-select"
                slot="prepend"
                placeholder="请选择"
              >
                <el-option
                  v-for="item in typeOptions"
                  :key="item.value"
                  :label="item.label"
                  :value="item.value"
                ></el-option>
              </el-select>
              <el-select
                v-model="secondCondition4"
                class="second-select"
                slot="prepend"
                placeholder="请选择"
              >
                <el-option
                  v-for="item in titleOptions"
                  :key="item.value"
                  :label="item.label"
                  :value="item.value"
                ></el-option>
              </el-select>
              <el-button slot="append" icon="el-icon-minus" @click="firstAdd=false"></el-button>
            </el-input>
          </div>
          <div class="el-form-item" v-if="secondAdd">
            <el-input
              placeholder="请输入内容"
              size="medium"
              v-model="conditions5"
              class="input-with-select"
            >
              <el-select
                v-model="firstCondition5"
                class="first-select"
                slot="prepend"
                placeholder="请选择"
              >
                <el-option
                  v-for="item in typeOptions"
                  :key="item.value"
                  :label="item.label"
                  :value="item.value"
                ></el-option>
              </el-select>
              <el-select
                v-model="secondCondition5"
                class="second-select"
                slot="prepend"
                placeholder="请选择"
              >
                <el-option
                  v-for="item in titleOptions"
                  :key="item.value"
                  :label="item.label"
                  :value="item.value"
                ></el-option>
              </el-select>
              <el-button slot="append" icon="el-icon-minus" @click="secondAdd=false;"></el-button>
            </el-input>
          </div>
          <div class="el-form-item" v-if="thirdAdd">
            <el-input
              placeholder="请输入内容"
              size="medium"
              v-model="conditions6"
              class="input-with-select"
            >
              <el-select
                v-model="firstCondition6"
                class="first-select"
                slot="prepend"
                placeholder="请选择"
              >
                <el-option
                  v-for="item in typeOptions"
                  :key="item.value"
                  :label="item.label"
                  :value="item.value"
                ></el-option>
              </el-select>
              <el-select
                v-model="secondCondition6"
                class="second-select"
                slot="prepend"
                placeholder="请选择"
              >
                <el-option
                  v-for="item in titleOptions"
                  :key="item.value"
                  :label="item.label"
                  :value="item.value"
                ></el-option>
              </el-select>
              <el-button slot="append" icon="el-icon-minus" @click="thirdAdd=false"></el-button>
            </el-input>
          </div>
          <el-row>
            <el-col :span="18">
              <el-form-item label="发表时间">
                <el-date-picker
                  v-model="searchForm.time"
                  type="daterange"
                  unlink-panels
                  range-separator="至"
                  start-placeholder="开始日期"
                  end-placeholder="结束日期"
                  @change="changData"
                ></el-date-picker>
              </el-form-item>
            </el-col>
            <el-col :span="6">
              <el-button
                type="primary"
                size="medium"
                plain
                icon="el-icon-search"
                @click="searchData"
              >检索</el-button>
              <el-button
                plain
                size="medium"
                icon="el-icon-refresh-left"
                @click="resetForm('ruleForm')"
              >重置</el-button>
            </el-col>
          </el-row>
        </el-form>
        <div class="screen">
          <el-card class="box-card" shadow="never">
            <el-row class="type-item bot_border">
              <el-col class="type-left" :span="2">类型：</el-col>
              <el-col :span="22">
                <el-tag
                  v-for="(item,index) in typeList"
                  size="small"
                  :type="typeIndex===index?'success':'info'"
                  :key="index"
                  v-if="item.typeNum != 0"
                  @click="changeType(item.type,index)"
                >{{item.typeName}}（{{item.typeNum}}）</el-tag>
              </el-col>
            </el-row>
            <el-row class="type-item bot_border">
              <el-col class="type-left" :span="2">选择：</el-col>
              <el-col :span="22">
                <el-tag
                  v-for="(item,index) in fullList"
                  size="small"
                  :type="fullIndex===index?'success':'info'"
                  :key="index"
                  @click="changeFull(item.val,index)"
                >{{item.text}}</el-tag>
              </el-col>
            </el-row>
            <el-row class="type-item bot_border">
              <el-col class="type-left" :span="2">收录情况：</el-col>
              <el-col :span="22">
                <el-tag
                  v-for="(item,index) in includeInfos"
                  size="small"
                  :type="includeIndex===index?'success':'info'"
                  :key="index"
                  v-if="item.includeNum != 0"
                  @click="changeInclude(item.code,index)"
                >{{item.name}}（{{item.includeNum}}）</el-tag>
              </el-col>
            </el-row>
            <el-row class="type-item">
              <el-col class="type-left" :span="2">年度：</el-col>
              <el-col :span="22">
                <el-tag
                  v-for="(item,index) in yearList"
                  size="small"
                  :type="yearIndex===index?'success':'info'"
                  :key="index"
                  v-if="item.yearNum != 0"
                  @click="changeYear(item.year,index)"
                >{{item.year}}（{{item.yearNum}}）</el-tag>
              </el-col>
            </el-row>
          </el-card>
        </div>
        <el-row class="type-opr">
          <el-col :span="12">
            <el-button
              type="primary"
              size="medium"
              plain
              icon="el-icon-download"
              @click="excelDown"
            >导出excel</el-button>
          </el-col>
          <el-col :span="12" style="text-align: right">
            <span>排序方式：</span>
            <el-button-group>
              <el-button
                :type="searchForm.sortType==='XZL'?'success':'primary'"
                @click="changeSort('XZL')"
                size="medium"
                plain
              >
                下载量
                <i class="el-icon-bottom el-icon--right"></i>
              </el-button>
              <el-button
                :type="searchForm.sortType==='LLS'?'success':'primary'"
                @click="changeSort('LLS')"
                size="medium"
                plain
              >
                浏览数
                <i class="el-icon-bottom el-icon--right"></i>
              </el-button>
            </el-button-group>
          </el-col>
        </el-row>
        <el-card class="box-card result-card" shadow="never">
          <div slot="header" class="clearfix">
            <span>
              筛选结果
              <b>{{total}}条</b>
            </span>
          </div>
          <el-checkbox-group v-model="checkList">
            <div v-for="item in dataList" :key="item.id" class="text item">
              <p>
                <el-checkbox :label="item.id" class="list-check"></el-checkbox>
                <!-- <el-tag type="primary" size="mini" plain>{{item.includeInfo}}</el-tag> -->
              </p>
              <p>
                <b>
                  <router-link
                    class="recommend"
                    :to="{path:'details',query:{baseId:item.id,baseType:item.baseType}}"
                  >{{item.title}}</router-link>
                </b>
              </p>
              <p>
                <b>发明人：</b>
                {{item.inventor}}
              </p>
              <!-- <p><b>刊名：</b>Chinese journal of traumatology = Zhonghua chuang shang za zhi</p>
              <p><b>年卷期页：</b>220-8</p>-->
              <p>
                <b>专利号：</b>
                {{item.applyNo}}
              </p>
              <p>
                <b>申请机构：</b>
                {{item.applyUnit}}
              </p>
              <p>
                <b>摘要：</b>
                {{item.summary}}
              </p>
            </div>
          </el-checkbox-group>
        </el-card>
        <el-pagination
          background
          layout="prev, pager, next"
          :total="total"
          :current-page="currentPage"
          :page-size="pageSizes"
          @current-change="currentChange"
          style="text-align: right"
        ></el-pagination>
      </el-card>
    </div>
    <div class="clear"></div>
  </div>
</template>

<script>
import axios from 'axios'
import List from '../components/list'
import Search from '../components/search'
import Tags from '../components/tags'
import Operation from '../components/operation'
import Pages from '../components/pages.vue'
import hId from '../api'

export default {
  name: 'index',
  components: {
    List,
    Search,
    Tags,
    Operation,
    Pages,
  },
  data() {
    return {
      activeName: 'second',
      total: 0,
      currentPage: 1,
      pageSizes: 5,
      includeIndex: 0,
      fullIndex: 0,
      typeIndex: 0,
      yearIndex: 0,
      typeOptions: [
        {
          value: 'and',
          label: 'and',
        },
        {
          value: 'or',
          label: 'or',
        },
        {
          value: 'not',
          label: 'not',
        },
      ],
      titleOptions: [
        {
          value: 'inventor',
          label: '发明/设计人',
        },
        {
          value: 'applyNo',
          label: '专利号',
        },
        // {
        //   value: 'journal_name',
        //   label: '刊名',
        // },
        // {
        //   value: 'keywords',
        //   label: '关键词',
        // },
      ],
      searchForm: {
        startTime: '',
        endTime: '',
        typeVal: '0',
        fullVal: '-1',
        sortType: 'XZL',
        includeInfo: '0',
        yearVal: '-1',
        pageNo: 1,
        conditions1: '',
        conditions2: '',
        conditions3: '',
        conditions4: '',
        conditions5: '',
        conditions6: '',
      },
      conditions1: '',
      conditions2: '',
      conditions3: '',
      conditions4: '',
      conditions5: '',
      conditions6: '',
      firstCondition2: '',
      firstCondition3: '',
      firstCondition4: '',
      firstCondition5: '',
      firstCondition6: '',
      secondCondition1: '',
      secondCondition2: '',
      secondCondition3: '',
      secondCondition4: '',
      secondCondition5: '',
      secondCondition6: '',
      firstAdd: false,
      secondAdd: false,
      thirdAdd: false,
      typeList: [],
      fullList: [
        { val: '-1', text: '所有' },
        { val: '1', text: '包含全文' },
        { val: '0', text: '不包含全文' },
      ],
      includeInfos: [],
      yearList: [],
      dataList: [],
      checkList: [],
      animate: false,
      animate1: false,
      departmentList: [],
      authorList: [],
    }
  },
  mounted() {
    this.timer1 = setInterval(this.scroll, 5000)
    this.timer2 = setInterval(this.scroll1, 5000)
    // this.getList()
    // this.getAuthor()
    this.searchData()
    this.getNewList()
    this.getAllResult()
  },
  methods: {
    scroll() {
      let con1 = this.$refs.con1
      con1.style['marginTop'] = '-40px'
      this.animate = !this.animate
      var that = this // 在异步函数中会出现this的偏移问题，此处一定要先保存好this的指向
      setTimeout(function () {
        that.departmentList.push(that.departmentList[0])
        that.departmentList.shift()
        con1.style['marginTop'] = '0px'
        that.animate = !that.animate // 这个地方如果不把animate 取反会出现消息回滚的现象，此时把ul 元素的过渡属性取消掉就可以完美实现无缝滚动的效果了
      }, 1000)
    },
    scroll1() {
      let con2 = this.$refs.con2
      con2.style['marginTop'] = '-40px'
      this.animate1 = !this.animate1
      var that = this // 在异步函数中会出现this的偏移问题，此处一定要先保存好this的指向
      setTimeout(function () {
        that.authorList.push(that.authorList[0])
        that.authorList.shift()
        con2.style['marginTop'] = '0px'
        that.animate1 = !that.animate1 // 这个地方如果不把animate 取反会出现消息回滚的现象，此时把ul 元素的过渡属性取消掉就可以完美实现无缝滚动的效果了
      }, 1000)
    },
    mEnter(flag) {
      flag == 1 ? clearInterval(this.timer1) : clearInterval(this.timer2)
    },
    mLeave(flag) {
      flag == 1
        ? (this.timer1 = setInterval(this.scroll, 5000))
        : (this.timer2 = setInterval(this.scroll1, 5000))
    },
    getNewList() {
      axios({
        method: 'post',
        url: '/api/patent/selectPatByAuthor',
      })
        .then((res) => {
          this.authorList = res.data
        })
        .catch()
      axios({
        method: 'post',
        url: '/api/patent/selectPatByDept',
      })
        .then((res) => {
          this.departmentList = res.data
        })
        .catch()
    },
    // getList() {
    //   axios({
    //     method: 'get',
    //     url: '/api/scholar',
    //   })
    //     .then(res => {
    //       this.departmentList = res.data.data.deptList
    //     })
    //     .catch()
    // },
    // getAuthor(){
    //   axios({
    //     method: 'get',
    //     url: '/api/selectAuthorDiss/' + hId,
    //   })
    //     .then(res => {
    //       this.authorList = res.data
    //     })
    //     .catch()
    // },
    resetForm(formName) {
      this.conditions1 = ''
      this.conditions2 = ''
      this.conditions3 = ''
      this.conditions4 = ''
      this.conditions5 = ''
      this.conditions6 = ''
      this.firstCondition2 = ''
      this.firstCondition3 = ''
      this.firstCondition4 = ''
      this.firstCondition5 = ''
      this.firstCondition6 = ''
      this.secondCondition1 = ''
      this.secondCondition2 = ''
      this.secondCondition3 = ''
      this.secondCondition4 = ''
      this.secondCondition5 = ''
      this.secondCondition6 = ''
    },
    currentChange(val) {
      this.searchForm.pageNo = val
      this.searchData()
    },
    addSearch() {
      if (this.thirdAdd) {
      } else if (this.secondAdd) {
        this.thirdAdd = true
      } else if (this.firstAdd) {
        this.secondAdd = true
      } else {
        this.firstAdd = true
      }
    },
    changData(data) {
      if (data == undefined || data == null) {
        this.searchForm.startTime = ''
        this.searchForm.endTime = ''
      } else if (data.length == 2) {
        this.searchForm.startTime =
          data[0].getFullYear() +
          '-' +
          (data[0].getMonth() + 1) +
          '-' +
          data[0].getDate()
        this.searchForm.endTime =
          data[1].getFullYear() +
          '-' +
          (data[1].getMonth() + 1) +
          '-' +
          data[1].getDate()
      }
    },
    searchData() {
      let currThis = this
      if (this.secondCondition1 != '') {
        this.searchForm.conditions1 =
          this.secondCondition1 + ',' + this.conditions1
      } else {
        this.searchForm.conditions1 = ''
      }
      if (this.firstCondition2 != '' && this.secondCondition2 != '') {
        this.searchForm.conditions2 =
          this.firstCondition2 +
          ',' +
          this.secondCondition2 +
          ',' +
          this.conditions2
      } else {
        this.searchForm.conditions2 = ''
      }
      if (this.firstCondition3 != '' && this.secondCondition3 != '') {
        this.searchForm.conditions3 =
          this.firstCondition3 +
          ',' +
          this.secondCondition3 +
          ',' +
          this.conditions3
      } else {
        this.searchForm.conditions3 = ''
      }
      if (this.firstCondition4 != '' && this.secondCondition4 != '') {
        this.searchForm.conditions4 =
          this.firstCondition4 +
          ',' +
          this.secondCondition4 +
          ',' +
          this.conditions4
      } else {
        this.searchForm.conditions4 = ''
      }
      if (this.firstCondition5 != '' && this.secondCondition5 != '') {
        this.searchForm.conditions5 =
          this.firstCondition5 +
          ',' +
          this.secondCondition5 +
          ',' +
          this.conditions5
      } else {
        this.searchForm.conditions5 = ''
      }
      if (this.firstCondition6 != '' && this.secondCondition6 != '') {
        this.searchForm.conditions6 =
          this.firstCondition6 +
          ',' +
          this.secondCondition6 +
          ',' +
          this.conditions6
      } else {
        this.searchForm.conditions6 = ''
      }
      axios({
        method: 'post',
        url: '/api/patent/searchAllPatInfo',
        data: this.searchForm,
      })
        .then(function (response) {
          currThis.currentPage = response.data.current
          currThis.total = response.data.total
          currThis.pageSizes = response.data.size
          currThis.dataList = response.data.records
        })
        .catch(function (thrown) {})
    },
    excelDown() {
      let data = ''
      for (var i = 0; i < this.checkList.length; i++) {
        if (i === 0) {
          data += 'a' + this.checkList[i] + 'a'
        } else {
          data += this.checkList[i] + 'a'
        }
      }
      axios({
        method: 'get',
        url: '/api/index/exportExcel/1',
      })
        .then(function (response) {
          if (response.status === 200) {
            alert('导出成功')
          } else {
          }
        })
        .catch(function (thrown) {})
    },
    getAllResult() {
      let currThis = this
      axios({
        method: 'get',
        url: '/api/patent/retrievalPat',
      })
        .then(function (response) {
          let typeArr = [
            {
              baseType: '0',
              typeNum: response.data.data.count,
              typeName: '所有',
            },
          ]
          let includeArr = [
            {
              code: '0',
              name: '所有',
              includeNum: response.data.data.includeAll,
            },
          ]
          let yearArr = [{ year: '所有', yearNum: response.data.data.yearAll }]
          currThis.typeList = typeArr.concat(response.data.data.allTypeList)
          currThis.includeInfos = includeArr.concat(
            response.data.data.includeInfos
          )
          currThis.yearList = yearArr.concat(response.data.data.yearList)
        })
        .catch(function (thrown) {})
    },
    changeType(val, index) {
      this.searchForm.typeVal = val
      this.typeIndex = index
      this.searchData()
    },
    changeFull(val, index) {
      this.searchForm.fullVal = val
      this.fullIndex = index
      this.searchData()
    },
    changeInclude(val, index) {
      this.searchForm.includeInfo = val
      this.includeIndex = index
      this.searchData()
    },
    changeYear(val, index) {
      if (val == '所有') {
        val = '-1'
      }
      this.searchForm.yearVal = val
      this.yearIndex = index
      this.searchData()
    },
    changeSort(val) {
      this.searchForm.sortType = val
      this.searchData()
    },
  },
  beforeRouteLeave(to, from, next) {
    clearInterval(this.timer1)
    clearInterval(this.timer2)
    next()
  },
}
</script>

<style scoped>
div {
  box-sizing: border-box;
}
.left-box {
  float: left;
  width: 280px;
  margin-right: 60px;
  padding: 0 10px;
  background-color: #fafafa;
  font-size: 14px;
}
.right-box {
  float: right;
  width: 800px;
}
.clear {
  clear: both;
}
h2.tit {
  font-size: 18px;
  font-weight: 700;
  height: 44px;
  line-height: 44px;
  border-bottom: 1px solid #dddddd;
  padding: 0 0 0 15px;
  margin-bottom: 15px;
  background: url(../assets/images/tit_ico.png) no-repeat 0 14px;
}
.department {
  height: 200px;
  overflow: hidden;
  position: relative;
}
.author {
  height: 400px;
  overflow: hidden;
  position: relative;
}
.statistics_tit {
  display: flex;
  height: 40px;
  line-height: 40px;
  font-weight: 700;
}
.statistics_tit_1 {
  width: 120px;
}
.statistics_tit_2 {
  width: 70px;
  text-align: center;
}
.statistics {
  position: absolute;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
}
.anim {
  transition: all 0.5s;
}
.statistics li {
  display: flex;
  height: 40px;
  line-height: 40px;
}
.statistics li a {
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
}
</style>
<style>
.patent .el-card__body {
  padding: 0;
}
.patent .el-card {
  border: 0;
}
</style>



// WEBPACK FOOTER //
// src/pages/patent.vue